import SwiperItemComponent from "./SwiperItemComponent";

export default SwiperItemComponent;